var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6352 20.727V12.7658H16.3585L16.7671 9.66219H13.6352V7.68102C13.6352 6.78274 13.8885 6.17058 15.2032 6.17058L16.8774 6.16991V3.39397C16.5878 3.35707 15.594 3.27246 14.4373 3.27246C12.0219 3.27246 10.3683 4.71854 10.3683 7.37364V9.66219H7.63672V12.7658H10.3683V20.727H13.6352Z",
    fill: "#8B8B8B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_182_6884",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 10,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6352 20.727V12.7658H16.3585L16.7671 9.66219H13.6352V7.68102C13.6352 6.78274 13.8885 6.17058 15.2032 6.17058L16.8774 6.16991V3.39397C16.5878 3.35707 15.594 3.27246 14.4373 3.27246C12.0219 3.27246 10.3683 4.71854 10.3683 7.37364V9.66219H7.63672V12.7658H10.3683V20.727H13.6352Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_182_6884)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIc);
export default __webpack_public_path__ + "static/media/Facebook_ic.749ef993af4aab0bed6ea191f27dc3c2.svg";
export { ForwardRef as ReactComponent };